module.exports = __webpack_public_path__ + "2a4994fd4f04566dc5fdab1a6b9b5dc5.png";


//////////////////
// WEBPACK FOOTER
// ./public/logo_kbmob@2x.png
// module id = 207
// module chunks = 1